document.addEventListener('DOMContentLoaded', function () {
  const deferredVideos = document.querySelectorAll('deferred-media');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const deferredMedia = entry.target;
        const playButton = deferredMedia.querySelector('.deferred-media__poster');

        if (playButton) {
          // inietta stile temporaneo che blocca TUTTI gli outline
          const tempStyle = document.createElement('style');
          tempStyle.textContent = '* { outline: none !important; box-shadow: none !important; }';
          document.head.appendChild(tempStyle);

          playButton.style.opacity = '0';
          playButton.click();

          setTimeout(() => {
            if (document.activeElement) document.activeElement.blur();
            // rimuove lo stile temporaneo dopo il blur
            document.head.removeChild(tempStyle);
          }, 50);

          setTimeout(() => {
            const video = deferredMedia.querySelector('video');
            if (video) {
              video.muted = true;
              video.play();
            }
          }, 300);
        }

        observer.unobserve(deferredMedia);
      }
    });
  }, { threshold: 0.5 });

  deferredVideos.forEach(el => observer.observe(el));
});